import { render, staticRenderFns } from "./GroupEdit.vue?vue&type=template&id=17851460&scoped=true&"
import script from "./GroupEdit.vue?vue&type=script&lang=js&"
export * from "./GroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17851460",
  null
  
)

export default component.exports